import { ListItemButton as MuiListItemButton, type ListItemButtonProps as MuiListItemButtonProps } from '@mui/material';
import { useForkRef } from '@mui/material/utils';
import { type AnchorHTMLAttributes, forwardRef } from 'react';

import type { WithoutStyleOverrides } from '../../../types/WithoutStyleOverrides';

type Props = WithoutStyleOverrides<Omit<MuiListItemButtonProps, 'ref'>>
  & Pick<AnchorHTMLAttributes<HTMLAnchorElement>, 'href' | 'target' | 'rel' | 'download'>;

// forwardRef, not a `ref` prop: the app still runs React 18, where function components never receive `ref`.
export const ListItemButton = forwardRef<HTMLElement, Props>(function ListItemButton(props, ref) {
  const elementRef = useForkRef(ref);
  return <MuiListItemButton {...props} ref={elementRef} />;
});

export type { Props as ListItemButtonProps };
